import type { PageDef } from '../app/routes';
import { helpFor } from './registry';

export function HelpBody({ page }: { page: PageDef }) {
  const h = helpFor(page.id);
  return (
    <div className="space-y-5 text-sm leading-relaxed">
      <Section title="Purpose">{h.purpose}</Section>
      <Section title="What you enter">{h.enter}</Section>
      {h.tips && <Section title="Tip">{h.tips}</Section>}
      <p className="text-xs text-ink-muted">
        Shortcuts: <kbd>?</kbd> help, <kbd>Esc</kbd> close, <kbd>g</kbd> then a letter to jump between pages.
      </p>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section>
      <h3 className="mb-1 text-[11px] font-bold uppercase tracking-[0.08em] text-navy">{title}</h3>
      <p className="text-ink">{children}</p>
    </section>
  );
}
